import concert1 from '../../assets/hum1020/concert.png';
import concert2 from '../../assets/hum1020/concert-0.jpg';
import concert3 from '../../assets/hum1020/concert-1.png';
import concert4 from '../../assets/hum1020/concert-2.png';
import concert5 from '../../assets/hum1020/concert-3.png';
import concert7 from '../../assets/hum1020/concert7.jpg';
import concert8 from '../../assets/hum1020/concert8.jpg';
import concert9 from '../../assets/hum1020/concert9.jpg';
import concert10 from '../../assets/hum1020/concert10.jpg';
import concert1small from '../../assets/hum1020/concert-0.small.png';
import concert2small from '../../assets/hum1020/concert-1.small.png';
import concert3small from '../../assets/hum1020/concert-2.small.png';
import concert4small from '../../assets/hum1020/concert-3.small.png';
import concert5small from '../../assets/hum1020/concert-1.small.jpg';

export const galleryImages = [
  {
    src: concert1,
    thumbnail: concert1small,
    caption: 'All Participants',
  },
  {
    src: concert2,
    thumbnail: concert5small,
    caption: 'Michael and Jeorge singing Dear Theodosia',
  },
  {
    src: concert10,
    thumbnail: concert10,
    caption: 'Professor Edony Princivil playing the piano',
  },
  {
    src: concert4,
    thumbnail: concert3small,
    caption: 'Ms. Hui Quan Playing Galloping Horses'
  },
  {
    src: concert3,
    thumbnail: concert2small,
    caption: 'Alexis and Rebecca playing There\'s no way',
  },
  {
    src: concert5,
    thumbnail: concert4small,
    caption: 'Professor Edony Princivil singing Perfect Symphony by E. Sheeran',
  },
  {
    src: concert7,
    thumbnail: concert7,
    caption: 'Alexandra Sanchez playing Ecos de Amor',
  },
  {
    src: concert8,
    thumbnail: concert8,
    caption: 'Ms. Jue Zhou and Ms. Huie plaing Liang Liang',
  },
  {
    src: concert9,
    thumbnail: concert9,
    caption: 'Ceasar Escoto (coreographer), Michael and Sergio',
  },
];
